export const getTodayDate = (heure) => {
  const today = new Date();
  const year = today.getFullYear();
  let month = String(today.getMonth() + 1).padStart(2, "0"); // Add leading zero for single-digit months
  let day = String(today.getDate()).padStart(2, "0"); // Add leading zero for single-digit days

  return `${year}-${month}-${day} ${heure}`;
};

export const formattedDate = (date, active) => {
  var year = date.getFullYear();
  var month = ("0" + (date.getMonth() + 1)).slice(-2); // Month is zero-based, so we add 1 and pad with leading zero if needed
  var day = ("0" + date.getDate()).slice(-2); // Pad with leading zero if needed
  var hour = "10";
  var minute = "59";
  var second = "00";
  if (active == 2) {
    var hour = "12";
  }
  if (active == 3) {
    var hour = "16";
  }

  // Format the date and time
  return (
    year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second
  );
};

export const formattedDateYMD = (date) => {
  var year = date.getFullYear();
  var month = ("0" + (date.getMonth() + 1)).slice(-2); // Month is zero-based, so we add 1 and pad with leading zero if needed
  var day = ("0" + date.getDate()).slice(-2); // Pad with leading zero if needed

  // Format the date and time
  return year + "-" + month + "-" + day;
};

export const transformToTasks = (dataTable, tasks) => {
  let works = [];

  dataTable.forEach((element) => {
    let string = "";
    if (element.elements_numbers > 1) string = "(" + element.elements_numbers + ")";
    tasks["task_" + element.id] = {
      id: "task_" + element.id,
      content: `${element.reference_work} ${element.service.name}  ${string}  : [ Dr ${element.dentist.last_name} ${element.dentist.first_name} ]`,
      details: element,
    };
    works.push("task_" + element.id);
  });

  return [works, tasks];
};
